module.exports = __webpack_public_path__ + "img/1566670673.080550fd.jpg";